module.exports = __webpack_public_path__ + "img/mainPageIntro.3425e3aa.jpg";